import {CompletePayroll} from "../../../../app/interfaces";
import {NotifyEorContainer, PayrollBonusProvidedContainer} from "./styles";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {updatePayrollState} from "../../../../app/payroll/selectors";
import {updatePayroll} from "../../../../app/payroll/actions";
import {FETCH_STATUS_LOADING, PAYROLL_STATUS_PREPARING} from "../../../../utils/constants";
import {
    InputFieldsWrapper,
    InputText,
    PopupAskForConfirmation,
    PopupLoading,
    PrimaryButton
} from "../../../../components";

const PayrollBonusProvided = ({payroll}: {payroll: CompletePayroll}) => {
    const [showAskForConfirmation, setShowAskForConfirmation] = useState<boolean>(false)

    const statusUpdate = useSelector(updatePayrollState)

    const dispatch = useDispatch()

    const {t} = useTranslation()

    const handleEorNotified = () => {
        setShowAskForConfirmation(false)
        dispatch(updatePayroll({
            payrollId: payroll._id,
            employeeId: payroll.eor_employee._id,
            status: PAYROLL_STATUS_PREPARING
        }) as any)
    }

    if(statusUpdate === FETCH_STATUS_LOADING){
        return <PopupLoading isOpen={true}/>
    }

    return <PayrollBonusProvidedContainer>
        {showAskForConfirmation && <PopupAskForConfirmation
            title={t('confirm_eor_notified_title') as string}
            subtitle={t('confirm_eor_notified_message') as string}
            isOpen={showAskForConfirmation}
            onConfirm={handleEorNotified}
            onCancel={() => setShowAskForConfirmation(false)}
            type='hand_stop'
        />}

        <h1>{t('bonus_information_title')}</h1>
        <section>
            <InputFieldsWrapper>
                <InputText
                    readOnly
                    label={t('amount') as string}
                    value={payroll.bonus.amount}>
                </InputText>
                <InputText
                    readOnly
                    label={t('currency') as string}
                    value={payroll.bonus.currency}>
                </InputText>
            </InputFieldsWrapper>
            <InputText
                readOnly
                label={t('description') as string}
                value={payroll.bonus.description || ''}>
            </InputText>
        </section>
        <NotifyEorContainer>
            <PrimaryButton onClick={() => setShowAskForConfirmation(true)}>
                {t('already_notified_eor_partner')}
            </PrimaryButton>
        </NotifyEorContainer>
    </PayrollBonusProvidedContainer>
}

export default PayrollBonusProvided;
